import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';
import { AddGrandMasterBoxComponent } from '../add-grand-master-box/add-grand-master-box.component';
import { DialogComponent } from 'src/app/dialog.component';

@Component({
  selector: 'app-view-master-box-dispatch-detail',
  templateUrl: './view-master-box-dispatch-detail.component.html',
  styleUrls: ['./view-master-box-dispatch-detail.component.scss']
})
export class ViewMasterBoxDispatchDetailComponent implements OnInit {
  loader: boolean = false;
  smallBoxlisting: any = [];
  getStockColorWise: any = [];
  noScanListing: any = [];
  viewType: any;
  deleteItem: boolean = false;
  filter: any = {};
  dispatchItems: any = []
  dispatchItemsCoupons: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data, public toast: ToastrManager, public serve: DatabaseService, public dialog1: DialogComponent, public dialogRef: MatDialogRef<ViewMasterBoxDispatchDetailComponent>, public dialog: MatDialog,) {
  }

  ngOnInit() {
    this.viewType = this.data.type;
    console.log(this.viewType);
    

    if (this.viewType != 'dispatchItems' && this.viewType != 'getStockColorWise' && this.viewType != 'dispatchItemsCoupoon' ) {
      this.getMasterboxdata()
    }

    if (this.viewType == 'dispatchItems') {
      this.getDispatchedItems()
    }

    if (this.viewType == 'dispatchItemsCoupoon') {
      console.log("inside line 39")
      this.getDispatchedItemsCoupon()
    }

    if (this.viewType == 'getStockColorWise') {
      this.getcolorWiseStockDetails()
    }

  }
  getMasterboxdata() {
    this.loader = true;
    this.serve.post_rqst({ 'data': { 'id': this.data.main_data.id, 'type': this.viewType } }, "Dispatch/fetchMasterGrandCouponDetail").subscribe((result) => {

      if (result['statusCode'] == 200) {
        this.loader = false;
        this.smallBoxlisting = result['master_grand_coupon'];
        this.noScanListing = result['no_scan_master_grand_coupon'];

      } else {
        this.loader = false;
        this.toast.errorToastr(result['statusMsg']);
      }
    })
  }
  changeMasterbox(data, type) {
    const dialogRef = this.dialog.open(AddGrandMasterBoxComponent, {
      width: '500px',
      data: {
        data,
        type
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getMasterboxdata()

    });
  }

  closeDialog() {
    this.dialog.closeAll()
  }

  removeItem(id, order_id, master_box_id) {
    this.dialog1.confirm('Do you want to remove it from ' + this.data.main_data.coupon_code).then((result) => {
      if (result) {
        this.serve.post_rqst({ 'product_id': id, 'order_id': order_id, 'master_box_id': master_box_id }, "Dispatch/deleteNoScanDispatch").subscribe((result => {
          if (result['statusCode'] == 200) {
            this.toast.successToastr(result['statusMsg']);
            this.deleteItem = true;
            this.getMasterboxdata();
          } else {
            this.toast.errorToastr(result['statusMsg']);
          }
        }));
      }
    });
  }

  closeRefresh() {
    this.dialogRef.close(true);
  }

  getDispatchedItems() {
    this.loader = true;
    this.serve.post_rqst({ 'data': { 'id': this.data.main_data.id, 'type': this.viewType }, 'filter': this.filter }, "Dispatch/getDispatchOrderDetail").subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.loader = false;
        this.dispatchItems = result['result'];
      } else {
        this.toast.errorToastr(result['statusMsg']);
        this.loader = false;
      }
    })
  }

  getDispatchedItemsCoupon() {
    this.loader = true;
    this.serve.post_rqst({ 'data': { 'id': this.data.main_data.id,'product_id':this.data.main_data.product_id,'item_id':this.data.main_data.item_id,'order_id':this.data.main_data.order_id, 'type': this.viewType }, 'filter': this.filter }, "Dispatch/getDispatchOrderQrCodes").subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.loader = false;
        this.dispatchItemsCoupons = result['result'];
      } else {
        this.toast.errorToastr(result['statusMsg']);
        this.loader = false;
      }
    })
  }

  getcolorWiseStockDetails() {
    this.loader = true;
    this.serve.post_rqst({ 'data': { 'product_id': this.data.main_data.id,'flag':this.data.flag} }, "Stock/colorWiseStockDetails").subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.loader = false;
        this.getStockColorWise = result['result'];
      } else {
        this.loader = false;
        this.toast.errorToastr(result['statusMsg']);
      }
    })
  }

  openDialog(id,item_id,product_id,order_id, type) {
    console.log(order_id)
    let data = { 'main_data': { 'id': id,'item_id':item_id,'product_id':product_id,'order_id':order_id }, 'type': type }
    const dialogRef = this.dialog.open(ViewMasterBoxDispatchDetailComponent, {
      width: '1024px',
      panelClass: 'cs-modal',
      disableClose: true,
      data

    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

}
